import React, { useState, useEffect } from "react"; // Added useEffect
import { FiSearch } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import LocIcon from "../assets/images/loc1.png";
import { useSelector, useDispatch } from "react-redux";
import { useLanguage } from "../context/LanguageContext";
import "../styles/FindaCity.css";
import citiesByState from '../cities.json'; // Renamed import for clarity
import { getallCities,getCurrentLocation } from "../redux/cities/citiesSlice";
const FindaCity = () => {
  const { t } = useLanguage();
  const tfc = t.findCity;
  const [query, setQuery] = useState("");
  const [activeIndex, setActiveIndex] = useState(null);
  // State to hold a flattened list of all cities
  const [allCitiesFlattened, setAllCitiesFlattened] = useState([]); 
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
 
  const currentLocation = useSelector((state)=>state);
  const { cities = [], status, locationCity } = useSelector((state) => state.cities || {});


  // Use useEffect to flatten the JSON data once on component mount
  // console.log(cities);
  useEffect(() => {
    dispatch(getallCities());
    dispatch(getCurrentLocation());
  }, [dispatch]);
  useEffect(() => {
    const flattenedCities = [];
    for (const stateName in citiesByState) {
      if (Object.hasOwnProperty.call(citiesByState, stateName)) {
        // Concatenate all city arrays from each state
        flattenedCities.push(...citiesByState[stateName]);
      }
    }
    // Sort the cities alphabetically for better user experience (optional)
    flattenedCities.sort((a, b) => a.localeCompare(b));
    setAllCitiesFlattened(flattenedCities);
  }, []); 
useEffect(() => {
  if (locationCity && cities.length > 0) {
    const matched = cities.find(
      (city) => city.name?.toLowerCase() === locationCity.toLowerCase()
    );

    const formatted = locationCity.toLowerCase().replace(/\s+/g, "-");

    if (matched) {
      navigate(`/Available/${formatted}`);
    } else {
      navigate(`/NotAvailable/${formatted}`);
    }
  }
}, [locationCity, cities, navigate]);

  const questions = tfc && tfc.faq ? tfc.faq.map(item => ({
    question: item.question,
    answer: (
      <p style={{ whiteSpace: 'pre-line' }}>
        {item.answer}
      </p>
    )
  })) : [];

  const toggleQuestion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

const handleCityClick = (cityString) => {
  const cityNameFormatted = cityString.toLowerCase().replace(/\s+/g, "-");

  // Match against the actual city `name`, not countyName
  const matchedCity = cities.find(
    (city) =>
      city.name &&
      city.name.toLowerCase() === cityString.toLowerCase()
  );

  if (matchedCity) {
    navigate(`/Available/${cityNameFormatted}`);
  } else {
    navigate(`/NotAvailable/${cityNameFormatted}`);
  }
};


const handleSearchSubmit = () => {
  if (!query.trim()) return;

  const formattedQuery = query.toLowerCase().replace(/\s+/g, "-");

  const matchedCity = cities.find(
    (city) =>
      city.name &&
      city.name.toLowerCase() === query.toLowerCase()
  );

  if (matchedCity) {
    navigate(`/Available/${formattedQuery}`);
  } else {
    navigate(`/NotAvailable/${formattedQuery}`);
  }

  setQuery("");
};


  const handleSearch = (e) => {
    setQuery(e.target.value);
  };

  useEffect(() => {
  if (status === "idle") {
    dispatch(getallCities());
  }
}, [dispatch, status]);

  // Filter cities from the flattened array
  const filteredCities = allCitiesFlattened.filter((cityString) =>
    cityString.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <>
      <div className="find-city-wrapper">
       <div
  className="find-city-container"
  style={{
    width: '100%',
    maxWidth: '100%',
    margin: '0 auto',
    paddingTop: '20px',     // Optional: for spacing
    marginTop: '-100px'      // Pushes it upward
  }}
>

          <div className="city-search-box"
           style={{
    width: '100%', maxWidth: '50%',
    
  }}>
            <div className="input-wrapper">
              <input
                type="text"
                value={query}
                onChange={handleSearch}
                placeholder={tfc?.searchPlaceholder || "Find a city"}
                className="city-search-input"
                style={{
                  paddingTop: '5px',marginLeft:'-170px',
                  paddingBottom: '1px',
                  fontSize: '3rem',
                  fontWeight: 600,
                  border: 'none',
                  outline: 'none',
                  background: 'transparent',
                  fontFamily: 'Arial, Helvetica, sans-serif',
                  color: '#333',
                  width: '100%'
                }}
              />
            <div style={{ position: 'relative' }}>

  <label
    onClick={handleSearchSubmit}
    style={{
      position: 'absolute',
      left: '550px',
    
      transform: 'translateY(-130%)',
     
    }}
  >
    <FiSearch size={35} />
  </label>
</div>

              {query && filteredCities.length > 0 && (
                <ul className="dropdown">
                  {filteredCities.map((cityString, index) => (
                    <li key={index} onClick={() => handleCityClick(cityString)}>
                      <img src={LocIcon} alt="location" className="locicon" />
                      {cityString} 
                    </li>
                  ))}
                </ul>
              )}
               {query && filteredCities.length === 0 && query.trim() !== "" && ( // Only show "No cities found" if query is not empty
                <ul className="dropdown">
                  <li>{tfc?.noCitiesFound || "No cities found matching"} "{query}"</li>
                </ul>
              )}
            </div>
          </div>
        </div>

        <div className="find-image">
          <img src="/images/find-a-city.jpg" alt="ride" className="city-image" />
        </div>
      </div>

       <div className="faq-sections">
        <h1>{tfc?.faqTitle || "Frequently asked questions from our drivers"}</h1>
        <div className="faq-lists">
          {questions.map((item, index) => (
            <div
              key={index}
              className="faq-items"
              onClick={() => toggleQuestion(index)}
            >
              <div className="faq-questions">
                <span>{item.question}</span>
                <span className="plus-icon">
                  {activeIndex === index ? "×" : "+"}
                </span>
              </div>
              <div className={`faq-answers ${activeIndex === index ? "open" : ""}`}>
  {item.answer}
</div>

            </div>
          ))}
        </div>
      </div>

      <div
        className="signup-section"
        style={{
          backgroundColor: "#FEF4F5",
          clipPath: "polygon(0 40px, 100% 0, 100% 100%, 0% 100%)",
          padding: "60px 20px 40px",
          textAlign: "center",
        }}
      >
        <h1>{tfc?.ctaTitle || "Affordable rides are just tap away"}</h1>
        <p>{tfc?.ctaSubtitle || "Get affordable rides anywhere in your city and pay only $9.95 flat fee"}</p>
        <a href="https://play.google.com/store/apps/details?id=com.berymoflat&pli=1">
          <button className="ride">{tfc?.signUpToRide || "Sign Up To Ride"}</button>
        </a>
      </div>

      <style>
        {`
          .city-search-input {
            width: 100%;
            padding: 12px 16px;
            border: 1px solid #ccc;
            border-radius: 8px;
            font-size: 16px;
          }
            
           .find-image {
            position: relative;
            clip-path: polygon(0 5%, 100% 0%, 100% 95%, 0% 100%); /* Top and bottom slants */
            overflow: hidden;
            height: 750px;
          }

          .city-image {
            width: 100%;
            height: auto;
            display: block;
          }
@media (max-width: 768px) {
  .find-image {
    position: relative;
    width: 100%;
    height: 400px;
    overflow: hidden;
    clip-path: polygon(0 8%, 100% 0%, 100% 92%, 0% 100%);
  }

  .city-image {
    position: absolute;
    top: 0;
    left: 0;
    min-width: 190%;
    min-height: 100%;
    width: auto;
    height: auto;
    object-fit: cover;
    transform: scale(1) translateX(-15%);
    transform-origin: center;
  }
}



            @media (max-width: 768px) {
  .find-city-container {
    margin-top: -59px !important; /* less negative for smaller screens */
    padding-top: 10px !important;
  }

  .city-search-box {
    max-width: 90% !important;
    margin: 0 auto !important;
  }

  .city-search-input {
    font-size: 1.8rem !important;
    margin-left: -15px !important;
  }

  .find-city-wrapper label {
    left: 85% !important; /* relative to smaller screen */
    transform: translateY(-175%) !important;
  }
}
/* Add this to your CSS file */
@media (max-width: 768px) {
  .dropdown {
    right: 0 !important;
    left: auto !important;
    transform: translateX(0) !important;
    width: 90vw !important;
    max-width: 100% !important;
  }
}




          .dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.08);
  z-index: 1000;
  margin-top: 15px;
  padding: 0;
  list-style: none;
  transform: translateX(-280px);
  width: 90vw; 
  max-width: 850px; /* Optional max width */
}
  


          .dropdown li {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 8px 18px;
            font-size: 15px;
            color: #000000;
            
            cursor: pointer;
            transition: background-color 0.2s ease;
            border: none;
          }

          .dropdown li:hover {
            background-color: #f5f5f5;
            
          }

          .locicon {
            width: 16px;
            height: 16px;
            object-fit: contain;
          }
            
          @media (max-width: 768px) {
            .signup-section {
              clip-path: polygon(0 8px, 100% 0, 100% 100%, 0% 100%);
              margin-top: 100px;  /* keep your original margin */
              padding: 40px 16px 30px;
              text-align: center;
              transform: translateY(75px); /* moves it 50px down */
            }

            .signup-section h1 {
              font-size: 1.9rem;
              margin-bottom: 1rem;
            }

            .signup-section p {
              font-size: 0.95rem;
              margin-bottom: 1.5rem;
            }

            .signup-section .ride {
              width: 100%;
              padding: 0.8rem 1.2rem;
              font-size: 0.9rem;
            }
          }

            @media (max-width: 768px) {
              .find-city-container {
                width: 90%;
                margin-left: 5%; /* This pushes it a bit to the right */
              }

              .city-search-input::placeholder {
                font-weight: 600;     
                margin-top: 20px;
                font-size: 2rem;        
                color: #888888;           /* soft gray */
                font-family: 'Arial', 'Helvetica', sans-serif;  
                letter-spacing: 0.5px;
              }
              .city-search-input {
                font-size: 1.2rem;
                font-weight: 600;
                color: #333;
                margin-top: 20px;
                border: none;
                border-bottom: 1px solid #333;
                outline: none;
                padding: 10px 5px;
                background: transparent;
              }
              .input-wrapper label {
                margin-top: 20px; /* this moves the icon downward */
                cursor: pointer;
              }
            }
        `}
      </style>
    </>
  );
};

export default FindaCity;


